import React from 'react'
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Dropdown } from 'components'

const Container = styled.div`
    display: flex;
    align-items: center;
    /* background-color: ${props => props.owner && 'var(--secondary-color)'}; */
    padding: ${props => props.owner ? '0.25rem 0.5rem' : '0.5rem 0 0 0.5rem'};
    border-radius: 5px;
    /* :hover {
        filter: ${props => !props.ownwer && 'brightness(var(--brightness))'};
    }; */
`

const Text = styled.div`
    flex-grow: 4;
`

const Subtitle = styled.div`
    width: 5rem;
    padding: 0.5rem;
    font-size: 0.8rem;
    text-align: right;
`
const UserBlock = props => {
    const {
        user,
        onRemove,
        onChange
    } = props;
    // useEffect(() => {
    //     (accessType === 'REMOVE' & onRemove) && onRemove()
    // })

    const accessTypes = {
        VIEW: 'View',
        EDIT: 'Edit',
        REMOVE: 'Remove'
    }

    if(user.access === 'OWNER'){
        return (
            <Container owner={true}>
                <Text>{user.email}</Text>
                <Subtitle>Owner</Subtitle>
            </Container>
        )
    } else {
        return (
            <Container>
                <Text>{user.email}</Text>
                <Dropdown style={{placement:'bottom-end', width: '5rem', optionWidth: '6rem', padding: '0.5rem', backgroundColor: 'var(--secondary-color)', fontSize:'0.8rem', margin: '0'}}
                    value={accessTypes[user.access]} 
                    options={accessTypes} 
                    onSelect={(value) => onChange(user.uid, value)}/>
            </Container>
        )
    }

    
}

export default UserBlock